// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import filterFunnel01Icon from "@/assets/icons/filter-funnel-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FilterFunnel01IconProps = Omit<IconProps, "name">;

export function FilterFunnel01Icon(props: FilterFunnel01IconProps): React.ReactNode {
  return <Icon name={filterFunnel01Icon} {...props} />;
}
